module.exports = __webpack_public_path__ + "static/media/adopt-upg-pic.135dea8a.jpeg";